var _defs, _rect, _g, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwsMigration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    role: "img",
    "aria-label": "AWS consultation and migration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b82f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111827"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 64,
    fill: "url(#g)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 148,
    width: 148,
    height: 148,
    rx: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 216,
    width: 148,
    height: 148,
    rx: 20,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 322h88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 278l44 44-44 44"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 420,
    textAnchor: "middle",
    fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, Arial",
    fontSize: 56,
    fontWeight: 700,
    fill: "#ffffff"
  }, "\n    MIGRATION\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsMigration);
export default __webpack_public_path__ + "static/media/aws_migration.7b7d02c371166744ea255e306f86a364.svg";
export { ForwardRef as ReactComponent };